import styled from '../../../styles/theme';
import { SortBoxStyled } from '../SortBoxStyled';

export const SortBoxStyledDS = styled(SortBoxStyled)`
    font-family: DSAutomobiles;
`;
